import {
    fetchCombinationCategoryByConcatedIDs,
    fetchCombinationRelatedSearchesByConcatedIDs,
    fetchCombinationSuggestedCategoriesByConcatedIDs,
} from '@/redux/api/combinationCategory';
import { CombinationCategory } from '@/types/CombinationCategory';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { RelatedSearch } from '@/types/RelatedSearch';
import { SuggestedCategory } from '@/types/SuggestedCategory';

/* Action Types */
export const LOAD_COMBINATION_CATEGORY_FAIL = 'la/domain/category/LOAD_COMBINATION_CATEGORY_FAIL';
export const LOAD_COMBINATION_CATEGORY_SUCCESS = 'la/domain/category/LOAD_COMBINATION_CATEGORY_SUCCESS';
export const LOAD_COMBINATION_RELATED_SEARCHES_FAIL = 'la/domain/category/LOAD_COMBINATION_RELATED_SEARCHES_FAIL';
export const LOAD_COMBINATION_RELATED_SEARCHES_SUCCESS = 'la/domain/category/LOAD_COMBINATION_RELATED_SEARCHES_SUCCESS';
export const LOAD_COMBINATION_SUGGESTED_CATEGORIES_FAIL =
    'la/domain/category/LOAD_COMBINATION_SUGGESTED_CATEGORIES_FAIL';
export const LOAD_COMBINATION_SUGGESTED_CATEGORIES_SUCCESS =
    'la/domain/category/LOAD_COMBINATION_SUGGESTED_CATEGORIES_SUCCESS';

export interface State {
    combinationCategory: CombinationCategory;
    combinationRelatedSearches: RelatedSearch[];
    combinationSuggestedCategories: SuggestedCategory[];
}

/* reducer */
const DEFAULT_STATE: State = {
    combinationCategory: null,
    combinationRelatedSearches: [],
    combinationSuggestedCategories: [],
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case LOAD_COMBINATION_CATEGORY_FAIL:
            return {
                ...state,
                combinationCategory: null,
            };
        case LOAD_COMBINATION_CATEGORY_SUCCESS:
            return {
                ...state,
                combinationCategory: action.payload,
            };
        case LOAD_COMBINATION_SUGGESTED_CATEGORIES_FAIL:
            return {
                ...state,
                combinationSuggestedCategories: [],
            };
        case LOAD_COMBINATION_SUGGESTED_CATEGORIES_SUCCESS:
            return {
                ...state,
                combinationSuggestedCategories: action.payload,
            };
        case LOAD_COMBINATION_RELATED_SEARCHES_FAIL:
            return {
                ...state,
                combinationRelatedSearches: [],
            };
        case LOAD_COMBINATION_RELATED_SEARCHES_SUCCESS:
            return {
                ...state,
                combinationRelatedSearches: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.combinationCategory;

export const getCombinationCategory = createSelector(stateSelector, (state) => state.combinationCategory);
export const getCombinationSuggestedCategories = createSelector(
    stateSelector,
    (state) => state.combinationSuggestedCategories || []
);
export const getCombinationRelatedSearches = createSelector(
    stateSelector,
    (state) => state.combinationRelatedSearches || []
);

/* ACTION CREATORS */
export const fetchCombinationCategory = (concatedIDs: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);
    try {
        const response = await fetchCombinationCategoryByConcatedIDs({ concatedIDs, deployment });
        dispatch({
            payload: response.payload,
            type: LOAD_COMBINATION_CATEGORY_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { concatedIDs },
            payload: error,
            type: LOAD_COMBINATION_CATEGORY_FAIL,
        });
    }
};

export const fetchCombinationSuggestedCategories =
    (concatedIDs: string) => async (dispatch: Function, getState: Function) => {
        const state = getState();
        const deployment = getDeployment(state);
        try {
            const response = await fetchCombinationSuggestedCategoriesByConcatedIDs({ concatedIDs, deployment });
            dispatch({
                payload: response.payload,
                type: LOAD_COMBINATION_SUGGESTED_CATEGORIES_SUCCESS,
            });
        } catch (error) {
            dispatch({
                error: true,
                meta: { concatedIDs },
                payload: error,
                type: LOAD_COMBINATION_SUGGESTED_CATEGORIES_FAIL,
            });
        }
    };

export const fetchCombinationRelatedSearches =
    (concatedIDs: string) => async (dispatch: Function, getState: Function) => {
        const state = getState();
        const deployment = getDeployment(state);
        try {
            const response = await fetchCombinationRelatedSearchesByConcatedIDs({ concatedIDs, deployment });
            dispatch({
                payload: response.payload,
                type: LOAD_COMBINATION_RELATED_SEARCHES_SUCCESS,
            });
        } catch (error) {
            dispatch({
                error: true,
                meta: { concatedIDs },
                payload: error,
                type: LOAD_COMBINATION_RELATED_SEARCHES_FAIL,
            });
        }
    };
